module.exports = __webpack_public_path__ + "static/media/add hr dev. nd training.88647e28.svg";